import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDashboard, faDatabase, faEye, faEyeSlash, faGear,  faLock,  faPager,  faPowerOff, faUsers  } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as userActions from "../../redux/user/userActions"
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import URLPage from '../../endPoints/endpoints';


import * as hideNavbarActions from "../../redux/hideNavBar/hideNavbarActions"



function NavBar({title, role}) {
  const token = useSelector((state)=> state.us.current?.token)
   function parseJwt (token) {
     var base64Url = token.split('.')[1];
     var base64 = base64Url.replace('-', '+').replace('_', '/');
     return JSON.parse(window.atob(base64));
 };
  const [user, setUser] = useState('');
  const [newPasssword1, setNewpassword1] = useState('');
  const [newPasssword2, setNewpassword2] = useState('');
  const [passwordMatch, setPasswordMatch] = useState('');

  const [eye, setEye] = useState(false);
  const [eye2,  setEye2] = useState(false);



  const handleEye = () => {
    if (eye) {
      setEye(false)
      return
    } else {
      setEye(true)
    }
  }

    const handleEye2 = () => {
    if (eye2) {
      setEye2(false)
      return
    } else {
      setEye2(true)
    }
  }
  
  
  useEffect(() => {
    if (token) {
      
      setUser(parseJwt(token))


    }
  }, [])


  const rewritePassword = (e) => {
    e.preventDefault();

    if (newPasssword1 != newPasssword2) {
      setPasswordMatch('passwords not match');
      return 
    }
  axios.put(`${URLPage}${title == 'Manager' ? '/api/users/' : '/api/users/standar/'}${user.uid.uid}`,{'password': newPasssword1.trim() } ,{
    headers: 
    {
      'x-token': token
    }

  })
  .then(response => {
     alert(response.data.msg);
     dispatch(userActions.setCurrentUser(null));
     navigate('/')
  })
  .catch(error => {
    alert(error)
   return
  });




  }



 

  Modal.setAppElement('#root');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const logOut = () => {
    dispatch(userActions.setCurrentUser(null));
   
    if (title == 'Manager') {
      return navigate('/')
    } else {
      return navigate('/')
    }
  }


  
  

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenChangePassword, setModalIsOpenChangePassword] = useState(false);

  const handleModalOpenChangePassword = () => {
    if (!modalIsOpenChangePassword) {
      dispatch(hideNavbarActions.setHideNavbar())
      setModalIsOpenChangePassword(true)
      return
    }
    dispatch(hideNavbarActions.setHideNavbar())
    setModalIsOpenChangePassword(false)
  }
  
  const handleModalLogOut = () => {
       if (!modalIsOpen) {
      dispatch(hideNavbarActions.setHideNavbar())
      setModalIsOpen(true)
      return
    }
    dispatch(hideNavbarActions.setHideNavbar())
    setModalIsOpen(false)
  }

    const toggleRef = useRef();

  const handleToggleClick = () => {
    if (toggleRef.current) {
      toggleRef.current.click(); // simula un clic
    }
  };



    if (title) {
      return <>
      <Navbar expand="lg" bg="dark" variant="dark">
      <Container>
        
        <Navbar.Brand >{title}</Navbar.Brand>
        <Navbar.Toggle ref={toggleRef}  aria-controls="main-navbar"/>
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto">
             <Nav.Link> {user.uid?.mail}</Nav.Link>
               <NavDropdown title={ <FontAwesomeIcon icon={faGear} /> } id="basic-nav-dropdown">
                 <NavDropdown.Item as="div" >

                    <Nav.Link className="text-dark" onClick={handleModalOpenChangePassword}><FontAwesomeIcon icon={ faLock } />  Change password</Nav.Link>
                     
                 </NavDropdown.Item>
                 
               </NavDropdown>

                  <Nav.Link as={Link} to='/dashboard'><FontAwesomeIcon icon={ faDatabase } /> </Nav.Link>

                  {user.uid?.rol == 'ADMIN_ROLE' ? <><Nav.Link as={Link} to='/admin/list-users'><FontAwesomeIcon icon={ faUsers } /> </Nav.Link></> : ''}
                
                  <Nav.Link   onClick={handleModalLogOut}><FontAwesomeIcon icon={ faPowerOff }/> </Nav.Link>
             
            
                  
            
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>


      <Modal
        isOpen={modalIsOpen}     
        overlayClassName="glass-overlay"
        className="glass-content card"
        data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
      >
      <div></div>
      <h5 className="card-header">LogOut</h5>
      <div className="card-body">
       <h5 className="card-title">Do you want to log-out</h5>
   
     <div className="d-flex justify-content-between mx-auto" style={{ width: '90%' }}>
     <button className='btn btn-danger'  style={{ width: '45%' }} onClick={logOut}>YES</button>
      <button className='btn btn-primary'  style={{ width: '45%' }} onClick={handleModalLogOut}>NO</button>
     </div>
      </div>


      </Modal>

      <Modal
        isOpen={modalIsOpenChangePassword}     
        overlayClassName="glass-overlay"
        className="glass-content card"
        data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
      >
      <div></div>
      <h5 className="card-header">Change Password  <FontAwesomeIcon icon={faLock} /></h5>
      <div className="card-body">
        <small  className="form-text text-danger">{passwordMatch}</small>
      <form onSubmit={rewritePassword}>
        
        <div className="mb-3">
          <label htmlFor="campo1" className="form-label text-left">Password</label>
        <div className='input-group'>

          
          <input 
          type={!eye ? 'password' : 'text'} 
          className="form-control" 
          id="campo1"
          name='campo1'
          value={newPasssword1}
          onChange={(e) => setNewpassword1(e.target.value)} 
          placeholder="Enter Password"
          onClick={()=> setPasswordMatch('')}
          minLength="8"
          required
          />
               <button onClick={handleEye} className="btn  button-password" type="button">
                  <FontAwesomeIcon icon={eye ? faEye : faEyeSlash} />
                </button>
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="campo2" className="form-label">Rewrite password</label>
          <div className='input-group'>

            <input
          type={!eye2 ? 'password' : 'text'} 
          className="form-control" 
          id="campo2"
          name='campo2'
          value={newPasssword2}
          onChange={(e) => setNewpassword2(e.target.value)}  
          placeholder="Rewrite Password"
          onClick={()=> setPasswordMatch('')}
          minLength="8"
          required                  
          />

                <button onClick={handleEye2} className="btn  button-password" type="button">
                  <FontAwesomeIcon icon={eye2 ? faEye : faEyeSlash} />
                </button>
          </div>
        </div>
        <div className='d-flex justify-content-evenly'>
        <button type="submit" className="btn btn-primary">CHANGE</button>
         <button 
         type="button" 
         className="btn btn-danger"
         onClick={handleModalOpenChangePassword}
         >CANCEL</button>
        </div>
      </form>
    </div>

   
   
   


      </Modal>
 
      </>
    } else {
      return <>
      <Navbar expand="lg" bg="dark" variant="dark">
      <Container>
        <Navbar.Brand >Luxury Lawns - {role}</Navbar.Brand>
        
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto">
                
       
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

     



      </>
    }
    return  
}

export default NavBar
